import React from 'react';

const ChartSection = ({ children, title = "Activity Overview" }) => {
  return (
    <div className="mt-8 bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-bold text-golden-navy mb-4">{title}</h2>
      {children}
    </div>
  );
};

export default ChartSection;